export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Latin2-3aca170427d68cd2672b32cd7511f95d.woff";